import { BasicType } from "@easy-email-pro-core/constants";
import {
  ElementChildren,
  NavbarLinkElement,
} from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type NavbarLinkProps = RecursivePartial<
  NavbarLinkElement["attributes"]
> & {
  idx?: string | null;
  children?: ElementChildren | NavbarLinkElement["children"];
  data?: NavbarLinkElement["data"];
};

export function NavbarLink(props: NavbarLinkProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: NavbarLinkElement = {
    type: BasicType.NAVBAR_LINK,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
